import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectClients } from '../clients/clients.selectors';
import { LifeCycleState } from './life-cycle.state';

export const LIFE_CYCLE_FEATURE_KEY = 'LifeCycle';

export const selectLifeCycleState = createFeatureSelector<LifeCycleState>(LIFE_CYCLE_FEATURE_KEY);

// The selected client's departments are awaited separately by StoreInitializationService.
export const selectIsStoreInitialized = createSelector(selectClients, (clients) => !!clients);
